import React, {Component} from 'react'
import {connect} from 'react-redux'
import {capitalize} from "../../Constants/capitalize";
import { Icon } from 'semantic-ui-react'
import {modifyMcpMenuItem} from "../../Actions/ModifyMcpMenuItem";

class McpIndexMenuItem extends Component {
    constructor(props) {
        super(props);
    }

    modifyMenuItem = () => this.props.modifyMcpMenuItem(this.props.name)

    render() {
        let cName = "mcpIndexMenuItem";

        if (this.props.name === this.props.mcpMenuItem){
            cName += " mcpIndexMenuItemSelected";
        }

        return (
            <div className={cName} onClick={this.modifyMenuItem}>
                <Icon name={this.props.icon} />
                <p>{this.props.displayName || this.props.name}</p>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    mcpMenuItem: state.mainState.mcpMenuItem
})

const mapActionsToProps = {
    modifyMcpMenuItem: modifyMcpMenuItem
}

export default connect(mapStateToProps, mapActionsToProps)(McpIndexMenuItem)
